import { useOnlineStatus } from '@/hooks/useOnlineStatus';

/**
 * Full-width status bar shown whenever the browser reports it's offline.
 * Because the app uses an in-memory Firestore cache (lib/firebase.ts), an edit
 * made offline pends and is lost on reload — so a caregiver must know not to
 * rely on changes saving until they reconnect. Mounted once at the router root
 * (RouteTracker) so it covers every page and write surface — including the
 * onboarding flows (/welcome, /add-button) that sit outside AppShell.
 */
export function OfflineBanner() {
  const online = useOnlineStatus();
  if (online) return null;
  return (
    <div
      role="status"
      aria-live="polite"
      className="sticky top-0 z-40 flex items-center justify-center gap-2 bg-amber-100 px-3 py-2 text-center text-sm font-medium text-amber-900"
    >
      <span aria-hidden="true">⚠</span>
      You're offline — changes won't be saved until you reconnect.
    </div>
  );
}
